import { ApiHelper, IApiResponse } from "../../utils/api-helper";

const url = `${process.env.REACT_APP_API_ENDPOINT}/Identity`;
const sendPinCodeUrl = `${process.env.REACT_APP_API_ENDPOINT}/Identity/ResetPassword`;

interface IAuthSignin {
  userName: string;
  password: string;
}
class AuthService extends ApiHelper {
  constructor(_url: string) {
    super(_url);
  }

  public sign_in(body: IAuthSignin): Promise<IApiResponse | void> {
    try {
      return super.create(body, { name: "Login" });
    } catch (e) {
      throw e;
    }
  }
  public token_sign_in(body: IAuthSignin): Promise<IApiResponse | void> {
    try {
      return super.create(body, { name: "LoginByToken" });
    } catch (e) {
      throw e;
    }
  }
  public sendPinCode(userName: string): Promise<IApiResponse | void> {
    try {
      this.url = sendPinCodeUrl;
      return super.getById(userName);
    } catch (e) {
      throw e;
    } finally {
      this.url = url;
    }
  }

  public checkPinIsValid(body: any): Promise<IApiResponse | void> {
    try {
      return super.create(body, { name: "CheckPinIsValid" });
    } catch (e) {
      throw e;
    }
  }

  public changePassword(body: any): Promise<IApiResponse | void> {
    try {
      return super.create(body, { name: "ChangePassword" });
    } catch (e) {
      throw e;
    }
  }
}
const authAPI = new AuthService(url);
export default authAPI;
